import { render, staticRenderFns } from "./investRatioEdit.vue?vue&type=template&id=37533656&scoped=true&"
import script from "./investRatioEdit.vue?vue&type=script&lang=js&"
export * from "./investRatioEdit.vue?vue&type=script&lang=js&"
import style0 from "./investRatioEdit.vue?vue&type=style&index=0&id=37533656&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37533656",
  null
  
)

export default component.exports